/**
 * Helper service, to be able to mock and spy on the methods.
 */
export const LocationService = {
  assign: (url) => { window.location = url },
  reload: (force) => window.location.reload(force),
  replace: (url) => window.location.replace(url)
}
